<template>
    <!-- 메인팝업 -->
    <div class="popup" :class="{ active: main_popup }" v-if="popupCnt > 0">
        <div class="main-popup">
            <h3 class="main-popup--title">
                <img src="@/assets/resource/img/main/main-popup--title--brain_txt.png" alt="">
                <p class="strong">POPUP ZONE</p>
            </h3>
            <div class="main-popup__cont">
                <p class="main-popup__cont--top">팝업 전체 · <span>{{popupCnt}}개</span></p>
                <swiper
                class="main-popup-swiper"
                :modules="modules"
                :slidesPerView="1"
                :speed="600"
                :spaceBetween="40"
                :breakpoints="{
                    720: { slidesPerView: 2 },
                    1312: { slidesPerView: 3 }
                }"
                :navigation="{
                    nextEl: '.main-popup-swiper__button.next',
                    prevEl: '.main-popup-swiper__button.prev'
                }"
                >
                    <swiper-slide class="main-popup__item" v-for="popup in popupList" :key="popup.attachBag.bannerImg[0].attachNo">
                        <a :href="popup.link ? popup.link : 'javascript:;'" :target="popup.target">
                        <img
                            :src="`/displayFile.do?attachNo=${popup.attachBag.bannerImg[0].attachNo}`"
                            :alt="popup.attachBag.bannerImg[0].altValue || '이미지'"
                            v-if="popup.attachBag.bannerImg"
                        />
                        </a>
                    </swiper-slide>
                </swiper>
                <div class="main-popup-swiper__button-wrap">
                    <button class="main-popup-swiper__button prev"></button>
                    <button class="main-popup-swiper__button next"></button>
                </div>
            </div>
            <div class="main-popup__button-wrap">
                <a href="javascript:;" class="main-popup__button02" @click="closePopup" style="background-image:none;">오늘 하루 열지 않기</a>
                <a href="javascript:;" class="main-popup__button" @click.prevent="main_popup_close"></a>
            </div>
        </div>
    </div>

    <!-- 쳇봇 -->
    <a href="javascript:;" class="chetbot cv" @click="chatbotOpen">
        <img src="@/assets/resource/img/main/chetbot2.gif" alt="" />
        <h3 class="chetbot-tit">CHATBOT</h3>
    </a>
    <!-- 쳇봇팝업 -->
    <div class="popup popup-chetbot" :class="{ active: popup_chetbot }">
        <div class="popup__inner">
            <div class="popup__tit">
                <h2>이대뇌혈관병원 찾아가는 길</h2>
                <button type="button" class="popup__close" @click="popup_chetbot_active"><img src="@/assets/resource/icon/close.svg" alt="" /></button>
            </div>
            <div class="popup__body">
                <div class="popup-chetbot__left">
                    <div class="popup-chetbot__left__top">
                        <div class="popup-chetbot__left__top__cont">
                            <h3 class="popup-chetbot__left--title">출발지</h3>
                            <div class="select">
                                <a href="javascript:;" class="select--btn" :class="{ active: chetbot_select }" @click.prevent="activechetbot_select">{{ mapStartTxt }}</a>
                                <slide-up-down :active="chetbot_select" class="select-option">
                                    <a href="javascript:;" class="select-option--btn" @click="[setMapList('B1'), activechetbot_select()]">지하1층 발산역 8번출구</a>
                                    <a href="javascript:;" class="select-option--btn" @click="[setMapList('main'), activechetbot_select()]">1층 정문</a>
                                    <a href="javascript:;" class="select-option--btn" @click="[setMapList('north'), activechetbot_select()]">1층 북문</a>
                                    <a href="javascript:;" class="select-option--btn" @click="[setMapList('parking'), activechetbot_select()]">지하주차장 B3~B5</a>
                                </slide-up-down>
                            </div>
                        </div>
                        <div class="popup-chetbot__left__top__cont">
                            <h3 class="popup-chetbot__left--title">도착지</h3>
                            <h4 class="title03">이대뇌혈관병원</h4>
                        </div>
                    </div>
                    <div class="popup-chetbot__left__bottom">
                        <div class="popup-chetbot__left__bottom__cont">
                            <p v-html="mapList[mapIndex].start"></p>
                            <span class="arrow"></span>
                            <p v-html="mapList[mapIndex].end"></p>
                        </div>
                        <div class="popup-chetbot__btn-wrap">
                            <a href="javascript:;" :class="{ 'popup-chetbot__btn': true, active: mapIndex == 1 }" @click="mapIndex = 0">이전 경로</a>
                            <a href="javascript:;" :class="{ 'popup-chetbot__btn': true, active: mapIndex == 0 }" @click="mapIndex = 1">다음 경로</a>
                        </div>
                    </div>
                </div>
                <div class="popup-chetbot__right">
                    <div class="popup-chetbot__img">
                        <img :src="require(`@/assets/resource/img/main/${mapList[mapIndex].src}`)" alt="" />
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="main">
        <section class="brain-sec brain-sec01">
          <div style="animation-delay:0s; translate:0 20%; z-index:0;" class="main-visual__title pc-none">
            <p style="color:#fff; font-size:21px; letter-spacing:0;">24시간 365일 뇌혈관 지킴이</p>
            <h3 style="color:#fff; font-size:48px; font-weight:600;">이대뇌혈관병원</h3>
            <div style="margin-top:80px;" class="main-visual__scrolldown">
              <p style="color:#2d184b">SCROLL</p><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAhCAYAAADQ1StpAAAApElEQVR4nO2SsQ3DMAwEL5ogJUtnAA7hmo02deXa2SABPEBUuswGTiMHAUzLKlPoKwH8OxCEoBAVW1VsLXVCaViTJmiCJmiCJvg7gYpFFetqIRW7qlgECPkxAFONJHcewKBiMQB3IAHdmSTPptxNwDPMy/gG+jOJA/fzMqZLqQC88vjmwQBfwYFk2yR58E7gSH6zg8H5B7mw3aQIuxs4m3AEA3wAkIhD1yL4Tw0AAAAASUVORK5CYII=" alt="">
            </div>
          </div>
            <div class="brain-sec01_scroll mo-none">
                <img src="@/assets/resource/img/main/main_scroll.png" alt="" />
            </div>
            <div class="brain-kv__video">
                <video src="@/assets/resource/video/cv_main_visual.mp4" class="" autoplay muted loop></video>
                <!-- mo -->
                <img src="@/assets/resource/img/brain-sec01.png" class="pc-none" stlye="height:100%;" alt="" />
            </div>
            <div class="brain-sec01__tab">
                <div class="brain-sec01__wrap">
                    <button type="button" class="brain-sec01__btn" :class="{ active: sec01Tab }" @click="this.sec01Tab = !this.sec01Tab"><span>Quick</span><span class="icon"></span></button>
                    <ul class="brain-sec01__list">
                        <li class="brain-sec01__item">
                            <a href="javascript:;" class="brain-sec01__link" @click="showPopup('firstVisible')">
                                <span class="icon"></span>
                                <span class="tit">첫진료예약</span>
                            </a>
                        </li>
                        <li class="brain-sec01__item">
                            <a href="javascript:;" class="brain-sec01__link" @click="showPopup('alarmVisible')">
                                <span class="icon"></span>
                                <span class="tit">알림톡서비스</span>
                            </a>
                        </li>
                        <li class="brain-sec01__item">
                            <a href="/kr/mypage/reservation/selectReservation" class="brain-sec01__link">
                                <span class="icon"></span>
                                <span class="tit">예약확인</span>
                            </a>
                        </li>
                        <li class="brain-sec01__item">
                            <a href="/kr/reservation/proof" class="brain-sec01__link">
                                <span class="icon"></span>
                                <span class="tit">증명서발급</span>
                            </a>
                        </li>
                        <li class="brain-sec01__item">
                            <a href="/kr/doctorList" class="brain-sec01__link">
                                <span class="icon"></span>
                                <span class="tit">의료진찾기</span>
                            </a>
                        </li>
                        <li class="brain-sec01__item">
                            <a href="javascript:;" class="brain-sec01__link" @click="popup_chetbot_active">
                                <span class="icon"></span>
                                <span class="tit">찾아가는 길</span>
                            </a>
                        </li>
                        <li class="brain-sec01__item">
                            <a href="/kr/mypage/headNote/headNote" class="brain-sec01__link">
                                <span class="icon"></span>
                                <span class="tit">두통수첩</span>
                            </a>
                        </li>
                        <li class="brain-sec01__item">
                            <a href="/kr/mypage/health/bloodMain" class="brain-sec01__link">
                                <span class="icon"></span>
                                <span class="tit">혈압수첩</span>
                            </a>
                        </li>
                        <li class="brain-sec01__item">
                            <a href="https://www.eumc.ac.kr/fund/join/write.do" class="brain-sec01__link" target="_blank">
                                <span class="icon"></span>
                                <span class="tit">후원하기</span>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </section>

        <section class="brain-sec brain-sec02">
            <div class="brain__inner">
                <p class="brain__sub-tit">
                    Cerebrovascular
                </p>
                <h2 class="brain__tit">‘이대뇌혈관병원의 특별함’</h2>
                <div class="brain-sec02__wrap">
                    <ul class="brain-sec02__list">
                        <li class="brain-sec02__item item1">
                            <h3>
                                급성기뇌졸중 <br />
                                적정성 평가 1등급
                            </h3>
                        </li>
                        <li class="brain-sec02__item item2">
                            <h3>
                                뇌혈관병원 <br />
                                전용 병동
                            </h3>
                        </li>
                        <li class="brain-sec02__item item3">
                            <h3>
                                24시간<br />
                                전문의 수술/시술<br />
                                개두술
                            </h3>
                        </li>
                        <li class="brain-sec02__item item4">
                            <h3>
                                중환자실 <br />
                                전병상 1인실
                            </h3>
                        </li>
                        <li class="brain-sec02__item item5">
                            <h3>
                                뇌졸중 재활센터 <br />
                                집중치료
                            </h3>
                        </li>
                    </ul>
                </div>
            </div>
        </section>

        <section class="brain-sec section02 brain-sec03">
            <ul class="section02__backgroundtext">
                <li>
                    <img src="@/assets/resource/img/main/brain-sec03__backgroundtext1.png" alt="" />
                </li>
                <li>
                    <img src="@/assets/resource/img/main/brain-sec03__backgroundtext2.png" alt="" />
                </li>
            </ul>
            <div class="inner">
                <div class="section02__background">
                    <img class="section02__background-ball1" src="@/assets/resource/img/main/section02__background-ball.png" alt="" />
                    <img class="section02__background-ball2" src="@/assets/resource/img/main/section02__background-ball2.png" alt="" />
                    <img class="section02__background-ball3" src="@/assets/resource/img/main/section02__background-ball3.png" alt="" />
                    <span class="section02__background-smollball no1"></span>
                    <span class="section02__background-smollball no2"></span>
                    <span class="section02__background-smollball no3"></span>
                    <span class="section02__background-smollball no4"></span>
                    <span class="section02__background-smollball no5"></span>
                    <span class="section02__background-smollball no6"></span>
                </div>

                <div class="section02_top_title transition01">
                    <h4>
                        24/365 뇌혈관 지킴이 <br />
                        이대뇌혈관병원
                    </h4>
                </div>

                <!-- pc -->
                <div class="brain-sec03__slide mo-none">
                    <div class="swiper section02-swiper">
                        <div class="section02__list transition02 swiper-wrapper">
                            <div :class="`section02__list--aa swiper-slide section02__list--item0${idx + 1}`" v-for="(doctor, idx) in doctorList" :key="idx">
                                <a href="javascript:;" :class="`section02__list--item cursor doctor0${idx + 1}`" :data-drsid="doctor.drSid" :data-deptcd="doctor.mainDeptCd">
                                    <div class="section02__list--item--img">
                                        <img :src="`/displayFile.do?attachNo=${doctor.attachBag.thumbs[0].attachNo}`" :alt="doctor.attachBag.thumbs[0].altValue || '이미지'" v-if="doctor.attachBag.thumbs" />
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div class="section02-swiper-button-wrap">
                            <button class="section02-swiper-button-next"></button>
                            <button class="section02-swiper-button-prev"></button>
                        </div>
                    </div>
                    <div class="swiper section02-swiper2">
                        <div class="section02_bottom_title transition02 swiper-wrapper">
                            <div :class="{ 'swiper-slide': true, on: idx == 2 }" v-for="(doctor, idx) in doctorList" :key="idx">
                                <h4>{{ doctor.name }} 교수</h4>
                                <p>{{ doctor.detailField }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- mo -->
            <div class="pc-none">
                <swiper
                    :slidesPerView="1.6"
                    :centeredSlides="true"
                    :spaceBetween="30"
                    :grabCursor="true"
                    :navigation="{
                        nextEl: '.section02-swiper-button-next',
                        prevEl: '.section02-swiper-button-prev'
                    }"
                    :modules="modules"
                    :initialSlide="2"
                    class="swiper03"
                >
                    <swiper-slide class="swiper03__slide" v-for="(doctor, idx) in doctorList" :key="idx">
                        <a href="javascript:;" :class="`section02__list--item cursor doctor0${idx + 1}`" :data-drsid="doctor.drSid" :data-deptcd="doctor.mainDeptCd">
                            <div class="section02__list--item--img">
                                <img :src="`/displayFile.do?attachNo=${doctor.attachBag.thumbs[0].attachNo}`" :alt="doctor.attachBag.thumbs[0].altValue || '이미지'" v-if="doctor.attachBag.thumbs" />
                            </div>
                        </a>
                        <div class="swiper03__text">
                            <h4 class="tit">{{ doctor.name }} 교수</h4>
                            <p class="desc">{{ doctor.detailField }}</p>
                        </div>
                    </swiper-slide>
                </swiper>
                <div class="section02-swiper-button-wrap">
                    <button class="section02-swiper-button-next"></button>
                    <button class="section02-swiper-button-prev"></button>
                </div>
            </div>
        </section>

        <section class="brain-sec brain-sec04">
            <div class="bg-icon bg-icon01"><img src="@/assets/resource/img/sec04-box.png" alt="" /></div>
            <div class="btn-wrap mo-show">
                <button type="button" class="swiper04-btn swiper04-prev"></button>
                <button type="button" class="swiper04-btn swiper04-next"></button>
            </div>
            <div class="brain-sec04__img">
                <div class="bg-icon bg-icon02"><img src="@/assets/resource/img/sec04-box.png" alt="" /></div>
                <swiper
                    :spaceBetween="30"
                    :effect="'fade'"
                    :navigation="{
                        nextEl: '.swiper04-next',
                        prevEl: '.swiper04-prev'
                    }"
                    :loop="true"
                    :modules="modules"
                    class="swiper04"
                    @slideChangeTransitionStart="onSlideChange"
                >
                    <swiper-slide class="swiper04-slide slide1">
                        <div class="swiper04-slide__inner">
                            <p class="swiper04-slide__text">
                                Ischemic <br />
                                Storoke <br />
                                Center
                            </p>
                            <div class="img">
                                <img src="@/assets/resource/img/sec04-slide01.png" alt="" />
                            </div>
                        </div>
                    </swiper-slide>
                    <swiper-slide class="swiper04-slide slide2">
                        <div class="swiper04-slide__inner">
                            <p class="swiper04-slide__text">
                                Hemorrhagic <br />
                                Storoke <br />
                                Center
                            </p>
                            <div class="img">
                                <img src="@/assets/resource/img/sec04-slide02.png" alt="" />
                            </div>
                        </div>
                    </swiper-slide>
                    <swiper-slide class="swiper04-slide slide3">
                        <div class="swiper04-slide__inner">
                            <p class="swiper04-slide__text">
                                Stereotactic <br />
                                Radiosurgery <br />
                                Center
                            </p>
                            <div class="img">
                                <img src="@/assets/resource/img/sec04-slide03.png" alt="" />
                            </div>
                        </div>
                    </swiper-slide>
                    <swiper-slide class="swiper04-slide slide4">
                        <div class="swiper04-slide__inner">
                            <p class="swiper04-slide__text">
                                Stroke <br />
                                Rehabilitation <br />
                                Center
                            </p>
                            <div class="img">
                                <img src="@/assets/resource/img/sec04-slide04.png" alt="" />
                            </div>
                        </div>
                    </swiper-slide>
                </swiper>
            </div>

            <div class="brain-sec04__text">
                <div class="line-box">
                    <div class="line"></div>
                    <p>Best center</p>
                </div>
                <div class="btn-wrap">
                    <button type="button" class="swiper04-btn swiper04-prev"></button>
                    <button type="button" class="swiper04-btn swiper04-next"></button>
                </div>
                <ul class="brain-sec04__list swiper04-txt">
                    <li class="brain-sec04__item text1 show">
                        <div class="top">
                            <p class="brain__sub-tit">
                                Cerebrovascular
                            </p>
                            <h2 class="brain__tit">뇌경색센터 소개</h2>
                            <p class="brain__desc">이대뇌혈관병원 뇌경색센터는 급만성 뇌경색 환자의 진단, 치료, 예방 등을 포함한 전방위 진료 제공을 목표로 하고 있습니다.</p>
                        </div>
                        <div class="bottom">
                            <a href="/kr/center?deptCd=ST1" class="more">
                                View more
                                <div class="icon">
                                    <img src="@/assets/resource/icon/arrow-right.svg" alt="" />
                                    <img src="@/assets/resource/icon/arrow-right.svg" alt="" />
                                </div>
                            </a>
                        </div>
                    </li>
                    <li class="brain-sec04__item text2">
                        <div class="top">
                            <p class="brain__sub-tit">Cerebrovascular</p>
                            <h2 class="brain__tit">뇌출혈센터 소개</h2>
                            <p class="brain__desc">이대뇌혈관병원 뇌출혈센터에서는 다양한 출혈성 뇌혈관 질환에 대한 예방, 진단 및 치료를 제공하고 있습니다.</p>
                        </div>
                        <div class="bottom">
                            <a href="/kr/center?deptCd=ST2" class="more">
                                View more
                                <div class="icon">
                                    <img src="@/assets/resource/icon/arrow-right.svg" alt="" />
                                    <img src="@/assets/resource/icon/arrow-right.svg" alt="" />
                                </div>
                            </a>
                        </div>
                    </li>
                    <li class="brain-sec04__item text3">
                        <div class="top">
                            <p class="brain__sub-tit">Cerebrovascular</p>
                            <h2 class="brain__tit">뇌정위방사선 치료센터 소개</h2>
                            <p class="brain__desc">이대서울병원 뇌정위방사선치료센터에서는 최첨단 방사선치료장비인 트루빔(TrueBeam)의 하이퍼아크 (HyperArc)솔루션으로 정밀방사선수술을 시행하고 있습니다.</p>
                        </div>
                        <div class="bottom">
                            <a href="/kr/center?deptCd=BRC" class="more">
                                View more
                                <div class="icon">
                                    <img src="@/assets/resource/icon/arrow-right.svg" alt="" />
                                    <img src="@/assets/resource/icon/arrow-right.svg" alt="" />
                                </div>
                            </a>
                        </div>
                    </li>
                    <li class="brain-sec04__item text4">
                        <div class="top">
                            <p class="brain__sub-tit">Cerebrovascular</p>
                            <h2 class="brain__tit">뇌졸중재활센터소개</h2>
                            <p class="brain__desc">뇌졸중재활센터에서는 뇌졸중이나 뇌손상 후 발생한 신체적 마비와 인지 기능 저하 및 연하장애에 대한 치료를 시행합니다.</p>
                        </div>
                        <div class="bottom">
                            <a href="/kr/center?deptCd=SRHC" class="more">
                                View more
                                <div class="icon">
                                    <img src="@/assets/resource/icon/arrow-right.svg" alt="" />
                                    <img src="@/assets/resource/icon/arrow-right.svg" alt="" />
                                </div>
                            </a>
                        </div>
                    </li>
                </ul>
            </div>
        </section>

        <section class="brain-sec brain-sec05">
            <div class="brain__inner">
                <div class="box1">
                    <div class="brain-sec05__text">
                        <div class="top">
                            <div class="brain__sub-tit">
                                Video contents
                                <a href="/kr/br_vascularTV/list" class="brain__sub-tit--btn"></a>
                            </div>
                            <h2 class="brain__tit">혈관e-TV</h2>
                            <p class="brain__desc">이대뇌혈관병원의 다양한 영상들을 만나보세요.</p>
                        </div>

                        <div class="bottom">
                            <div class="btn-wrap">
                                <button type="button" class="swiper05-btn swiper05-prev"></button>
                                <button type="button" class="swiper05-btn swiper05-next"></button>
                            </div>
                            <div class="bottom">
                                <a href="/kr/br_vascularTV/list" class="more">
                                    View more
                                    <div class="icon">
                                        <img src="/img/arrow-right.f13d5a1c.svg" alt="" />
                                        <img src="/img/arrow-right.f13d5a1c.svg" alt="" />
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="brain-sec05__slide" v-if="tvList.length > 0">
                        <swiper
                            :breakpoints="{ 0: { spaceBetween: 25 }, 1024: { spaceBetween: 50 } }"
                            :slidesPerView="'auto'"
                            :navigation="{
                                nextEl: '.box1 .swiper05-next',
                                prevEl: '.box1 .swiper05-prev'
                            }"
                            :loop="true"
                            :modules="modules"
                            class="swiper05"
                        >
                            <swiper-slide class="swiper05__slide" v-for="article in tvList" :key="article.articleNo">
                                <a :href="`/${$store.getters.getLang}/${article.boardId}/view?boardNo=${article.boardNo}&articleNo=${article.articleNo}`" :target="$commonUtils.isExternal(article.linkUrl) ? article.linkMethod : '_self'" class="swiper05__link">
                                    <div class="img">
                                        <img :src="`/displayFile.do?attachNo=${ article.attachBag.thumbs[0].attachNo }`" :alt="article.attachBag.thumbs[0].altValue || '이미지'" v-if="article.attachBag.thumbs">
                                        <img :src="`https://img.youtube.com/vi/${$commonUtils.getYoutubeId(article)}/mqdefault.jpg`" alt="이미지" v-else>
                                    </div>
                                    <div class="swiper05__tit">{{article.title}}</div>
                                    <div class="swiper05__date">{{$commonUtils.dateToStr(new Date(article.createdDt), '.')}}</div>
                                </a>
                            </swiper-slide>
                        </swiper>
                    </div>
                </div>

                <div class="box2">
                    <div class="brain-sec05__slide" v-if="storyList.length > 0">
                        <swiper
                            :slidesPerView="'auto'"
                            :navigation="{
                                nextEl: '.box2 .swiper05-next',
                                prevEl: '.box2 .swiper05-prev'
                            }"
                            :loop="true"
                            :modules="modules"
                            :breakpoints="{ 0: { spaceBetween: 25 }, 1024: { spaceBetween: 50 } }"
                            class="swiper05"
                        >
                            <swiper-slide class="swiper05__slide" v-for="article in storyList" :key="article.articleNo">
                                <a :href="article.linkUrl ? article.linkUrl : `/${$store.getters.getLang}/${article.boardId}/view?boardNo=${article.boardNo}&articleNo=${article.articleNo}`" :target="$commonUtils.isExternal(article.linkUrl) ? article.linkMethod : '_self'" class="swiper05__link">
                                    <div class="img">
                                        <img :src="`/displayFile.do?attachNo=${ article.attachBag.thumbs[0].attachNo }`" :alt="article.attachBag.thumbs[0].altValue || '이미지'" v-if="article.attachBag.thumbs">
                                        <img :src="`https://img.youtube.com/vi/${$commonUtils.getYoutubeId(article)}/mqdefault.jpg`" alt="이미지" v-else>
                                    </div>
                                    <div class="swiper05__tit">{{article.title}}</div>
                                </a>
                            </swiper-slide>
                        </swiper>
                    </div>
                    <div class="brain-sec05__text">
                        <div class="top">
                            <div class="brain__sub-tit">
                                Column contents
                                <a href="/kr/br_vascularStory/list" class="brain__sub-tit--btn"></a>
                            </div>
                            <h2 class="brain__tit">혈관 E-이야기</h2>
                            <p class="brain__desc">이대뇌혈관병원의 다양한 건강이야기를 만나보세요.</p>
                        </div>

                        <div class="bottom">
                            <div class="btn-wrap">
                                <button type="button" class="swiper05-btn swiper05-prev"></button>
                                <button type="button" class="swiper05-btn swiper05-next"></button>
                            </div>
                            <div class="bottom">
                                <a href="/kr/br_vascularStory/list" class="more">
                                    View more
                                    <div class="icon">
                                        <img src="/img/arrow-right.f13d5a1c.svg" alt="" />
                                        <img src="/img/arrow-right.f13d5a1c.svg" alt="" />
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="brain-sec brain-sec06">
            <div class="brain__inner">
                <div class="brain-sec06__text">
                    <div class="top">
                        <div class="brain__sub-tit">
                            News contents
                            <a href="/kr/vie_notice/list" class="brain__sub-tit--btn"></a>
                        </div>
                        <h2 class="brain__tit">병원소식</h2>
                    </div>

                    <div class="bottom">
                        <div class="bottom">
                            <a href="/kr/vie_notice/list" class="more">
                                View more
                                <div class="icon"><img src="/img/arrow-right.f13d5a1c.svg" alt="" /><img src="/img/arrow-right.f13d5a1c.svg" alt="" /></div
                            ></a>
                        </div>
                    </div>
                </div>
                <ul class="brain-sec06__list">
                    <div class="brain-sec06__item" v-for="(article, index) in noticeList" :key="article.articleNo">
                        <a :href="`/${$store.getters.getLang}/${article.boardId}/view?boardNo=${article.boardNo}&articleNo=${article.articleNo}`" class="brain-sec06__link">
                            <span class="text-wrap">
                                <span class="num"><em>0{{ index + 1 }}</em></span>
                                <span class="tit">{{article.title}}</span>
                            </span>
                            <span class="arrow">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 106 32" fill="none" class="img">
                                    <path d="M5.2998 24L98.0498 24" stroke="#888888" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round" />
                                    <path d="M79.5 5.33594L98.05 24.0026" stroke="#888888" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round" />
                                </svg>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 106 32" fill="none" class="img">
                                    <path d="M5.2998 24L98.0498 24" stroke="#888888" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round" />
                                    <path d="M79.5 5.33594L98.05 24.0026" stroke="#888888" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round" />
                                </svg>
                            </span>
                        </a>
                    </div>
                </ul>
            </div>
        </section>

        <div class="footer__center-wrap type2">
            <div class="footer__center-list">
                <ul>
                    <li class="footer__center-item">
                        <a href="javascript:;" class="footer__center-link"><span class="name">EWHA FAMILY</span></a>
                    </li>
                    <li class="footer__center-item">
                        <a href="https://www.eumc.ac.kr/main.do" class="footer__center-link" target="_blank"> <span class="name">의료원</span></a>
                    </li>
                    <li class="footer__center-item">
                        <a href="https://mokdong.eumc.ac.kr/main.do" class="footer__center-link" target="_blank"> <span class="name">이대목동병원</span></a>
                    </li>
                    <li class="footer__center-item">
                        <a href="https://seoul.eumc.ac.kr/main.do" class="footer__center-link" target="_blank"> <span class="name">이대서울병원</span></a>
                    </li>
                    <li class="footer__center-item">
                        <div class="effect-icon"></div>
                        <a href="https://part.eumc.ac.kr/dept/pogoonyogoan/index.do" class="footer__center-link" target="_blank">
                            <span class="name"><img src="@/assets/resource/img/main/bogu_logo.png" alt="" style="margin-right: 5px" />보구녀관</span></a
                        >
                    </li>

                    <li class="footer__center-item">
                        <a href="http://ewhabrain.eumc.ac.kr" class="footer__center-link" target="_blank"> <span class="name">이대뇌혈관병원</span></a>
                    </li>
                    <li class="footer__center-item">
                        <a href="http://aorta.eumc.ac.kr" class="footer__center-link" target="_blank"> <span class="name">이대대동맥혈관병원</span></a>
                    </li>
                    <li class="footer__center-item">
                        <a href="http://mombaby.eumc.ac.kr" class="footer__center-link" target="_blank"> <span class="name">이대엄마아기병원</span></a>
                    </li>
                    <li class="footer__center-item">
                        <a href="https://wch.eumc.ac.kr/main.do" class="footer__center-link" target="_blank"> <span class="name">이대여성암병원</span></a>
                    </li>
                    <li class="footer__center-item">
                        <a href="https://ewui.eumc.ac.kr/main.do" class="footer__center-link" target="_blank"> <span class="name">이대비뇨기병원</span></a>
                    </li>
                    <li class="footer__center-item">
                        <a href="https://blood.eumc.ac.kr/" class="footer__center-link" target="_blank"> <span class="name">이대혈액암병원</span></a>
                    </li>
                </ul>
            </div>
        </div>
    </div>

    <kr_FirstReserveInputPopUp :popupVisible="firstVisible" @hide-popup="hidePopup"/>
    <kr_AlarmTalkInputPopup :popupVisible="alarmVisible" @hide-popup="hidePopup"/>
</template>
<script>
import { Swiper, SwiperSlide } from 'swiper/vue';
import { FreeMode, Pagination, Navigation, Thumbs, EffectFade } from 'swiper/modules'; // EffectFade 추가
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/effect-fade';
import 'swiper/css/navigation';
import 'swiper/css/thumbs';
import SlideUpDown from 'vue-slide-up-down';

import { gsap, Power1 } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

export default {
    components: {
        SlideUpDown,
        Swiper,
        SwiperSlide
    },
    data() {
        return {
            firstVisible: false,
            alarmVisible: false,
            sec01Tab: false,
            slideNum: '',
            chetbot_select: false,
            popup_chetbot: false,
            mapList: [
                { src: 'map_B1.jpg', start: '지하1층 발산역 8번출구', end: '외래전용 엘리베이터<br>& 에스컬레이터' },
                { src: 'map_3F.jpg', start: '3층 하차', end: '엘리베이터 좌측 위치<br>이대뇌혈관병원' }
            ],
            mapIndex: 0,
            doctorList: [],
            mapStartTxt: '지하1층 발산역 8번출구',
            drSids: '1004540,1005101,1012649,1019621,1019623,1019794',

            noticeBoardId: '',
            noticeList: [],
            tvList: [],
            storyList: [],

            lineCnt: 0,
            lineList: [],
            popupCnt: 0,
            popupList: [],
            main_popup: true,
            main_line: false,
        };
    },
    setup() {
        return {
            modules: [EffectFade, Navigation, Pagination]
        };
    },
    methods: {
        showPopup(param) {
            this[param] = true;
        },
        hidePopup(param) {
            this[param] = false;
        },
        getMainBanner() {
            const param = {
                hospId: this.$store.getters.getHost
            }
            this.axios.get(this.api.banner.main, {
                params: param
            }).then(res => {
                // 팝업
                const popup = res.data.popup
                this.popupCnt = popup.totCnt
                this.popupList = popup.list

                if(this.popupCnt > 0){
                    this.main_popup = true

                    const oneDay = 24 * 60 * 60 * 1000
                    const now = new Date().getTime()

                    const popupLastVisit = localStorage.getItem('popupTime_brain')
                    const popupLastVisitTime = popupLastVisit ? parseInt(popupLastVisit, 10) : null
                    const popupTimeSinceLastVisit = popupLastVisitTime ? now - popupLastVisitTime : null

                    if (popupLastVisitTime && popupTimeSinceLastVisit < oneDay) {
                        this.main_popup = false;
                    }
                }else{
                    this.main_popup = false
                }
            })
        },
        closePopup() {
            this.main_popup = false;
            const now = new Date().getTime()
            localStorage.setItem('popupTime_brain', now.toString())
        },
        main_popup_close() {
            this.main_popup = false;
        },
        getMainBoardList() {
            const param = {
                pageRow: 6
            }
            this.axios.get(this.api.article.main, {
                params: param
            })
                .then(res => {
                    const list = res.data
                    if(list){
                        const hostName = this.$store.getters.getHostName;
                        let prefix = 'aorta'
                        if (hostName == 'ewhabrain') {
                            prefix = 'vie';
                        } else if (hostName == 'mombaby') {
                            prefix = 'vie';
                        }
                        this.noticeBoardId = list['notice'].length > 0 ? list['notice'][0].boardId : `${prefix}_notice`
                        if(list['notice']){
                            const len = list['notice'].length
                            this.noticeList = list['notice'].slice(0, Math.min(len, 3))
                        }
                        this.tvList = list['tv'] || []
                        this.storyList = list['story'] || []
                    }

                    // Swiper 초기화
                    // this.nextTick(() => {
                    //     this.boardSwipers();
                    // });
                })
        },
        onSlideChange(swiper) {
            const activeSlide = document.querySelector('.brain-sec04 .swiper-slide-active');
            if (activeSlide && activeSlide.classList.contains('slide1')) {
                // slide1에 해당하는 active slide가 있을 때 실행할 코드
                document.querySelector('.text1').classList.add('show');
            } else {
                document.querySelector('.text1').classList.remove('show');
            }
            if (activeSlide && activeSlide.classList.contains('slide2')) {
                document.querySelector('.text2').classList.add('show');
            } else {
                document.querySelector('.text2').classList.remove('show');
            }
            if (activeSlide && activeSlide.classList.contains('slide3')) {
                document.querySelector('.text3').classList.add('show');
            } else {
                document.querySelector('.text3').classList.remove('show');
            }
            if (activeSlide && activeSlide.classList.contains('slide4')) {
                document.querySelector('.text4').classList.add('show');
            } else {
                document.querySelector('.text4').classList.remove('show');
            }
        },
        chatbotOpen() {
            const w = 450;
            const h = 550;
            let xPos = document.body.offsetWidth / 2 - w / 2;
            xPos += window.screenLeft; // 듀얼 모니터일 때
            const yPos = document.body.offsetHeight / 2 - h / 2;

            window.open('https://pf.kakao.com/_xdvyYT/chat?bot=true', 'chatbot', `width=${w}, height=${h}, left=${xPos}, top=${yPos}, menubar=yes, status=yes, titlebar=yes, resizable=yes`);
        },
        setMapList(start) {
            this.mapIndex = 0;
            this.mapList = [];
            if (start == 'B1') {
                this.mapStartTxt = '지하1층 발산역 8번출구';
                const obj = { src: 'map_B1.jpg', start: '지하1층 발산역 8번출구', end: '외래전용 엘리베이터<br>& 에스컬레이터' };
                this.mapList.push(obj);
            } else if (start == 'main') {
                this.mapStartTxt = '1층 정문';
                const obj = { src: 'map_1F_maingate.jpg', start: '1층 정문', end: '외래전용 엘리베이터<br>& 에스컬레이터' };
                this.mapList.push(obj);
            } else if (start == 'north') {
                this.mapStartTxt = '1층 북문';
                const obj = { src: 'map_1F_northgate02.jpg', start: '1층 북문', end: '외래전용 엘리베이터<br>& 에스컬레이터' };
                this.mapList.push(obj);
            } else if (start == 'parking') {
                this.mapStartTxt = '지하주차장 B3~B5';
                const obj = { src: 'map_parkingGarage.jpg', start: '지하주차장 B3~B5', end: '외래전용 엘리베이터<br>& 에스컬레이터<br>(주차 위치: F, G, H, I)' };
                this.mapList.push(obj);
            }
            const obj = { src: 'map_3F.jpg', start: '3층 하차', end: '엘리베이터 좌측 위치<br>이대뇌혈관병원' };
            this.mapList.push(obj);
        },
        popup_chetbot_active() {
            this.popup_chetbot = !this.popup_chetbot;
        },
        activechetbot_select() {
            this.chetbot_select = !this.chetbot_select;
        },
        getDoctorList() {
            const drSids = "1004945,1012320,1012323,1015056,1017749"

            const param = {
                startIndex: 1,
                drSids: drSids,
                pageRow: 100,
                langCd: this.$store.getters.getLang,
                hospId: this.$store.getters.getHost,
                // drSids: this.drSids
            };
            this.axios.get(this.api.doctor.doctorList, { params: param }).then(res => {
                const arr = res.data.doctorList;
                const doctorListTemp = this.$commonUtils.distinctList(arr, 'name');

                //doctorList의 name이 송태진, 박무석, 조동영, 양서연, 박영희 순으로 정렬
                for(let i = 0; i < doctorListTemp.length; i++) {
                    if(doctorListTemp[i].name == '박무석') {
                        this.doctorList[0] = doctorListTemp[i];
                    } else if(doctorListTemp[i].name == '송태진') {
                        this.doctorList[1] = doctorListTemp[i];
                    } else if(doctorListTemp[i].name == '조동영') {
                        this.doctorList[2] = doctorListTemp[i];
                    } else if(doctorListTemp[i].name == '양서연') {
                        this.doctorList[3] = doctorListTemp[i];
                    } else if(doctorListTemp[i].name == '박영희') {
                        this.doctorList[4] = doctorListTemp[i];
                    }
                }




                if (arr && arr.length > 0) {
                    const item = this.doctorList[2];
                    this.doctorList[2] = this.doctorList[1];
                    this.doctorList[1] = item;
                }

                this.$nextTick(() => {
                    // 의료진 소개 이벤트
                    $('.section02__list .section02__list--aa .section02__list--item').click(function (event) {
                        event.preventDefault(); // 링크의 기본 동작 방지
                        var index = $(this).parent().index(); // 클릭한 링크의 부모 div 요소의 인덱스 가져오기
                        $('.section02_bottom_title div').removeClass('on'); // 모든 p 요소에서 'on' 클래스 제거
                        $('.section02_bottom_title div').eq(index).addClass('on'); // 해당 인덱스에 맞는 p 요소에 'on' 클래스 추가
                    });
                    $('.section02__list a').click(function () {
                        var classes = $(this).attr('class').split(' ');
                        if (!$(this).hasClass('doctor03')) {
                            $('.doctor03').addClass(classes);
                            $('.doctor03').removeClass('doctor03');
                            $(this).removeClass(classes);
                            $(this).addClass('doctor03 cursor section02__list--item');
                        } else {
                            const drSid = $(this).data('drsid');
                            const deptCd = $(this).data('deptcd');

                            //새창으로 이동
                            window.open(`/kr/doctorInfo?drSid=${drSid}&deptCd=${deptCd}`, '_blank');
                            //location.href = `/kr/doctorInfo?drSid=${drSid}&deptCd=${deptCd}`;
                        }
                    });
                });
            });
        },
        gsapFn() {
            if (window.innerWidth >= 721) {
                // sec1
                gsap.to('.brain-sec03', { scrollTrigger: { trigger: '.brain-sec03', start: 'top center', scrub: 4, toggleClass: { targets: '.brain-sec03', className: 'on' } } });
                gsap.from('.brain-kv__video', { padding: 0, delay: 2, duration: 1.2 });
                // gsap.from('.brain-sec01__tab', { bottom: -160, delay: 5, duration: 0.5 });
                gsap.from('.brain-sec01_scroll', { opacity: 0, y: -50, delay: 3, duration: 1.5 });
                gsap.from('.chetbot.cv', { opacity: 0, y: -50, delay: 3, duration: 1.5 });

                setTimeout(() => {
                    this.sec01Tab = true;
                }, 4000);

                // sec2
                gsap.from('.brain-sec02 .brain__sub-tit', { scrollTrigger: { trigger: '.brain-sec02', start: 'top 70%' }, duration: 1, y: 50, opacity: 0 });
                gsap.from('.brain-sec02 .brain__tit', { scrollTrigger: { trigger: '.brain-sec02', start: 'top 70%' }, duration: 1, delay: 0.5, y: 50, opacity: 0 });

                // 1
                // gsap.from('.brain-sec02 .brain-sec02__item', { scrollTrigger: { trigger: '.brain-sec02', start: 'top 70%' }, duration: .6, y: 100, opacity: 0, stagger: 0.3 });

                // 2
                gsap.to('.brain .footer__center-list', { scrollTrigger: { trigger: '.footer', start: 'top bottom', scrub: true, toggleClass: { targets: '.footer__center-list', className: 'on' } } });

                gsap.from('.brain-sec02 .brain-sec02__item.item1', { scrollTrigger: { trigger: '.brain-sec02', start: 'top 60%' }, duration: 1.5, x: 200 + '%', stagger: 0.3, ease: 'Power1.easeOut' });
                gsap.from('.brain-sec02 .brain-sec02__item.item2', { scrollTrigger: { trigger: '.brain-sec02', start: 'top 60%' }, duration: 1.5, x: 100 + '%', stagger: 0.3, ease: 'Power1.easeOut' });
                gsap.from('.brain-sec02 .brain-sec02__item.item3', { scrollTrigger: { trigger: '.brain-sec02', start: 'top 60%' }, duration: 1.5, stagger: 0.3, ease: 'Power1.easeOut' });
                gsap.from('.brain-sec02 .brain-sec02__item.item4', { scrollTrigger: { trigger: '.brain-sec02', start: 'top 60%' }, duration: 1.5, x: -100 + '%', stagger: 0.3, ease: 'Power1.easeOut' });
                gsap.from('.brain-sec02 .brain-sec02__item.item5', { scrollTrigger: { trigger: '.brain-sec02', start: 'top 60%' }, duration: 1.5, x: -200 + '%', stagger: 0.3, ease: 'Power1.easeOut' });

                // 3
                // gsap.from('.brain-sec02 .brain-sec02__item.item1', { scrollTrigger: { trigger: '.brain-sec02', start: 'top 70%' }, duration: 2, y: -200, opacity: 0, stagger: 0.3 });
                // gsap.from('.brain-sec02 .brain-sec02__item.item2', { scrollTrigger: { trigger: '.brain-sec02', start: 'top 70%' }, duration: 2, y: -100, opacity: 0, stagger: 0.3 });
                // gsap.from('.brain-sec02 .brain-sec02__item.item3', { scrollTrigger: { trigger: '.brain-sec02', start: 'top 70%' }, duration: 2, opacity: 0, stagger: 0.3 });
                // gsap.from('.brain-sec02 .brain-sec02__item.item4', { scrollTrigger: { trigger: '.brain-sec02', start: 'top 70%' }, duration: 2, y: 100, opacity: 0, stagger: 0.3 });
                // gsap.from('.brain-sec02 .brain-sec02__item.item5', { scrollTrigger: { trigger: '.brain-sec02', start: 'top 70%' }, duration: 2, y: 200, opacity: 0, stagger: 0.3 });

                // 4
                // gsap.from('.brain-sec02 .brain-sec02__item.item1', { scrollTrigger: { trigger: '.brain-sec02', start: 'top 70%' }, duration: 2, x: -200, stagger: 0.3 });
                // gsap.from('.brain-sec02 .brain-sec02__item.item2', { scrollTrigger: { trigger: '.brain-sec02', start: 'top 70%' }, duration: 2, x: -100, stagger: 0.3 });
                // gsap.from('.brain-sec02 .brain-sec02__item.item3', { scrollTrigger: { trigger: '.brain-sec02', start: 'top 70%' }, duration: 2, stagger: 0.3 });
                // gsap.from('.brain-sec02 .brain-sec02__item.item4', { scrollTrigger: { trigger: '.brain-sec02', start: 'top 70%' }, duration: 2, x: 100, stagger: 0.3 });
                // gsap.from('.brain-sec02 .brain-sec02__item.item5', { scrollTrigger: { trigger: '.brain-sec02', start: 'top 70%' }, duration: 2, x: 200, stagger: 0.3 });

                // sec4
                gsap.from('.brain-sec04 .bg-icon01', { scrollTrigger: { trigger: '.brain-sec04', start: 'top 60%' }, duration: 1.2, scale: 0, opacity: 0 });
                gsap.from('.brain-sec04 .bg-icon02', { scrollTrigger: { trigger: '.brain-sec04', start: 'top 60%' }, duration: 1.5, delay: 0.3, scale: 0, opacity: 0 });
                gsap.from('.brain-sec04 .brain-sec04__item .top', { scrollTrigger: { trigger: '.brain-sec04', start: 'top 60%' }, duration: 1.4, x: 100, opacity: 0 });
                gsap.from('.brain-sec04 .btn-wrap', { scrollTrigger: { trigger: '.brain-sec04', start: 'top 60%' }, duration: 1, delay: 0.3, x: 100, opacity: 0 });
                gsap.from('.brain-sec04 .bottom', { scrollTrigger: { trigger: '.brain-sec04', start: 'top 60%' }, duration: 1, delay: 0.5, x: 100, opacity: 0 });
                gsap.from('.brain-sec04 .brain-sec04__text .line', { scrollTrigger: { trigger: '.brain-sec04', start: 'top 60%' }, duration: 1.2, delay: 1.1, height: 0 });
                gsap.from('.brain-sec04 .brain-sec04__text .line + p', { scrollTrigger: { trigger: '.brain-sec04', start: 'top 60%' }, duration: 1, delay: 1, opacity: 0 });
                gsap.from('.brain-sec04 .swiper04', { scrollTrigger: { trigger: '.brain-sec04', start: 'top 60%' }, duration: 1.5, y: 100, opacity: 0 });

                // sec5
                gsap.from('.box1 .brain-sec05__text', { scrollTrigger: { trigger: '.brain-sec05', start: 'top 60%' }, duration: 0.7, x: 200, opacity: 0 });
                gsap.from('.box1 .brain-sec05__slide', { scrollTrigger: { trigger: '.brain-sec05', start: 'top 60%' }, duration: 1, x: 300, opacity: 0 });

                gsap.from('.box2 .brain-sec05__text', { scrollTrigger: { trigger: '.brain-sec05 .box2', start: 'top 60%' }, duration: 0.7, x: -200, opacity: 0 });
                gsap.from('.box2 .brain-sec05__slide', { scrollTrigger: { trigger: '.brain-sec05 .box2', start: 'top 60%' }, duration: 1, x: -300, opacity: 0 });

                // sec6
                gsap.from('.brain-sec06 .brain__sub-tit', { scrollTrigger: { trigger: '.brain-sec06', start: 'top 70%' }, duration: 1, y: 50, opacity: 0 });
                gsap.from('.brain-sec06 .brain__tit', { scrollTrigger: { trigger: '.brain-sec06', start: 'top 70%' }, duration: 1, delay: 0.5, y: 50, opacity: 0 });
                gsap.from('.brain-sec06 .bottom', { scrollTrigger: { trigger: '.brain-sec06', start: 'top 70%' }, duration: 1, delay: 0.7, y: 30, opacity: 0 });
                gsap.from('.brain-sec06 .brain-sec06__item', { scrollTrigger: { trigger: '.brain-sec06', start: 'top 70%' }, duration: 1, x: 100, delay: 0.5, opacity: 0, stagger: 0.3 });
            } else {
            }
        }
    },
    mounted() {
        this.getMainBanner()
        this.getMainBoardList()
        this.getDoctorList();
        this.gsapFn();

        gsap.to('.brain .footer__center-list', { scrollTrigger: { trigger: '.brain-sec02', start: 'top bottom', end: '-200%', scrub: true }, bottom: '0' });

        gsap.to('.chetbot', { scrollTrigger: { trigger: '.brain-sec02', start: 'top bottom', end: '-200%', scrub: 2 }, top: 80 });

        
    }
};
</script>
